<script setup lang="ts">
import CloseButton from './CloseButton.vue'

const {
  rangeStep = 'start',
  startRangeTitle = 'Příjezd',
  endRangeTitle = 'Odjezd',
} = defineProps<{
  rangeStep?: 'start' | 'end'
  startRangeTitle?: string
  endRangeTitle?: string
}>()

const { updateActiveDatepicker } = inject('activeDatepicker')
</script>

<template>
  <div
    class="border-b border-b-gray flex justify-between items-start pt-4 px-5 mb-2.5 sm:hidden"
  >
    <div>
      <button
        class="relative pb-2 mr-4 font-semibold start"
        :class="[{ 'is-active': rangeStep === 'start' }, { 'text-gray': rangeStep === 'end' }]"
        type="button"
        @click="updateActiveDatepicker('start')"
      >
        {{ startRangeTitle }}
      </button>

      <button
        class="relative pb-2 font-semibold end"
        :class="[{ 'is-active': rangeStep === 'end' }, { 'text-gray': rangeStep === 'start' }]"
        type="button"
        @click="updateActiveDatepicker('end')"
      >
        {{ endRangeTitle }}
      </button>
    </div>

    <CloseButton />
  </div>
</template>

<style scoped>
.is-active {
  @apply text-primary;

}

.is-active::after {
  @apply content-[""] absolute h-0.5 w-full bg-primary bottom-0 left-0 will-change-transform;

  animation-duration: .3s;
  animation-iteration-count: 1;
}

.start.is-active::after {
  animation-name: slide-left;
}

.end.is-active::after {
  animation-name: slide-right;
}

@keyframes slide-right {
  from {
    transform: translateX(-60px);
  }

  to {
    transform: translateX(0);
  }
}

@keyframes slide-left {
  from {
    transform: translateX(60px);
  }

  to {
    transform: translateX(0);
  }
}
</style>
